<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row mt-5 pt-3">
        <div class="col-4 mt-2">
          <input
            v-model="searchN"
            type="text"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder="Buscar lubricadores por cédula o por correo"
            autocomplete="off"
            v-on:focus="clearInput"
          />
        </div>
        <div class="col-1 mt-2">
          <button data-bs-toggle="tooltip" data-bs-placement="bottom" title="Buscar lubricador" class="btn btn-danger btn-block" @click="search()">
            <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
        <div style="display:flex;">
          <h6 style="margin-top:30px; margin-bottom:auto; margin-left:15px;" class="text-dark font-weight-bold">
            Filtrar
          </h6>
          <div class="col-10 mt-2">
            <div class="form-group">
              <select
                :class="{ 'is-danger': errors.status }"
                class="form-control"
                name="state"
                id="state"
                v-model="distri"
                v-on:change="searchByType()"
              >
                <option value="null" selected>Seleccione el distribuidor</option>
                <option v-for="data in listD" :key="data.id" :value="data.id">
                  {{ data.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-1 mt-2">
          <button data-bs-toggle="tooltip" data-bs-placement="bottom" title="Actualizar masivos" class="btn btn-success btn-block" @click="modalM()">
            <i class="fa fa-upload m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col-1 mt-2">
          <button data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reportes de actualización" class="btn btn-info btn-block" @click="irR()">
            <i class="fa fa-bars m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem;"
            role="status"
          ></div>
        </div>
      </template>

      <div class="row mt-4">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped table-sm">
              <caption class="visually-hidden">Listado de Lubricadores</caption>
              <thead>
                <tr>
                  <th scope="col" style="text-align: left">Nombre</th>
                  <th scope="col" style="text-align: left">Cédula</th>
                  <th scope="col" style="text-align: left">Correo</th>
                  <th scope="col" style="text-align: left">Puntos</th>
                  <th scope="col" style="text-align: left">Eventos</th>
                  <th scope="col" style="text-align: left">Acción</th>
                  <th scope="col" style="text-align: center">Insribir códigos</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in items" :key="'d' + `item-${i}`">
                  <td style="text-align: left">
                    {{ item.name }} {{ item.last_name }}
                  </td>
                  <td style="text-align: left">
                    {{ item.document_number }}
                  </td>
                  <td style="text-align: left">
                    {{ item.email }}
                  </td>
                  <td style="text-align: left">     
                    <h6>
                      <span v-if="item.coupon1.length != 0" class="badge badge-pill badge-danger">
                        {{ item.coupon1[0].amount }}
                      </span>
                    </h6>
                  </td>
                  <td style="text-align: left">
                    <h6>
                      <span class="badge badge-pill badge-success">
                        {{ item.event_points }}
                      </span>
                    </h6>
                  </td>
                  <td style="text-align: left">
                    <div class="btn-group" role="group">
                      <div class="btn-group" role="group">
                        <button
                          class="btn btn-info mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                          title="Editar"
                          @click="update(item)"
                        >
                          <i class="fa-solid fa-user-pen m-0 p-0" aria-hidden="true"></i>
                          <!-- <i
                            class="fa fa-pencil m-0 p-0"
                            aria-hidden="true"
                          ></i> -->
                        </button>
                      </div>
                    </div>
                  </td>
                  <td style="text-align:center">
                    <div class="btn-group" role="group">
                      <div class="btn-group" role="group">
                        <button
                          class="btn btn-danger mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                          title="Insribir códigos"
                          @click="registerCodes(item)"
                        >
                          <i
                            class="fa fa-pencil m-0 p-0"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row ">
        <div
          class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-2  "
          style="text-align: initial;"
        >
          <label class="text-p mt-2">
            Página {{ currentPage }} de {{ totalPages }}
            <strong class="text-danger"> | </strong> total: {{ totaItems }}
          </label>
        </div>
        <div class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-2 ">
          <div class="float-right">
            <v-pagination
              total-visible="2"
              v-model="currentPage"
              :page-count="totalPages"
              :classes="bootstrapPaginationClasses"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Editar Banner -->
    <div
      class="modal fade "
      id="modalUpdateL"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong> Editar lubricadores</strong> </label
                ><br />
              </div>

              <div class="col-12 m-0 p-0">
                <div class="row" style="text-align: left">
                  <div class="col-12  m-0 p-0">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Nombre completo *</strong>
                          </label>
                          <input
                            disabled
                            :class="{ 'is-danger': errors.name }"
                            type="text"
                            v-model="form.name"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.name"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.name }}</span
                        >
                      </div>

                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Correo *</strong>
                          </label>
                          <input
                            disabled
                            :class="{ 'is-danger': errors.email }"
                            type="text"
                            v-model="form.email"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.email"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.email }}</span
                        >
                      </div>

                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Cédula *</strong>
                          </label>
                          <input
                            disabled
                            :class="{ 'is-danger': errors.document_number }"
                            type="text"
                            v-model="form.document_number"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.document_number"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.document_number }}</span
                        >
                      </div>

                      <div class="col-6 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Puntos *</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.points }"
                            type="number"
                            v-model="numC"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.points"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.points }}</span
                        >
                      </div>

                      <div class="col-6 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Puntos de eventos *</strong>
                          </label>
                          <input
                            :disabled="isWon"
                            :class="{ 'is-danger': errors.event_points }"
                            type="number"
                            v-model="form.event_points"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.event_points"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.event_points }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updatePublication()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal inscripción de códigos -->
    <div
      class="modal fade "
      id="modalRegisterCodes"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>Inscribir códigos</strong>
                </label><br>
              </div>

              <div class="col-12 m-0 p-0">
                <div class="row" style="text-align: left">
                  <div class="col-12  m-0 p-0">
                    <div class="row">
                      <!-- <div class="col-6 mt-2">
                        <div class="form-group" style="margin-bottom:0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color:#616161; font-size:14px"
                            ><strong>Lote *</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': codesErrors.lote }"
                            type="text"
                            v-model="codesForm.lote"
                            class="form-control"
                            placeholder="Ingresa el lote aquí"
                            maxlength="2"
                          />
                        </div>
                        <span
                          v-if="codesErrors.lote"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ codesErrors.lote }}</span
                        >
                      </div> -->

                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom:0px">
                          <label
                            for="image"
                            style="color:#616161; font-size:14px"
                            ><strong>Códigos en archivo .xlsx *</strong></label
                          ><br />
                          <input
                            type="file"
                            accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-exce"
                            class="form-control-file mb-2"
                            style="color: black"
                            @change="onfileSelectedExcel()"
                            ref="codesForm"
                            :class="{ 'is-danger': codesErrors.codesFile }"
                          />
                        </div>
                        <span
                          v-if="codesErrors.codesFile"
                          class="text-danger small error-danger"
                          >{{ codesErrors.codesFile }}</span
                        ><br>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="assignCodes()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Inscribir códigos</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal actualizar masivo -->
    <div
      class="modal fade "
      id="modalUpdateM"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div v-if="loading.modal" class="row justify-content-center mt-5 pt-5">
        <div class="col-1 mt-5 pt-5">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem;"
            role="status"
          ></div>
        </div>
      </div>

      <div
        v-if="!loading.modal"
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong> Actualizar masivo</strong> </label
                ><br />
              </div>
              <div class="col-12 m-0 p-2 mb-3" style="text-align: left">
                <label class="text-info"> <strong>Ejemplo de csv</strong> </label><br/>
                <img alt="Lubricador" src="../../../../assets/ejemplo_lubricador.jpg" width="300" />
              </div>
              <div class="col-12 m-0 p-0">
                <div class="row" style="text-align: left">
                  <div class="col-12  m-0 p-0">
                    <div class="row">
                      <div class="col-12">
                        <form ref="form" style="text-align: initial">
                          <label
                            for="image"
                            style="color: #616161; font-size: 14px"
                            ><strong>Adjuntar archivo csv *</strong></label
                          ><br />
                          <input
                            type="file"
                            multiple
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            id="csv"
                            name="csv"
                            class="form-control-file mb-2"
                            style="color: black"
                            @change="onfileSelected($event)"
                            :class="{ 'is-danger': errorsFile || errorsFile2 }"
                          />
                          <span
                            v-if="errorsFile2"
                            class="text-danger small error-danger"
                            >{{ errorsFile2 }}</span
                          >
                          <span
                            v-if="errorsFile"
                            class="text-danger small error-danger"
                            >{{ errorsFile }}</span
                          ><br>
                        </form>
                      </div>
                      <div class="col-12 mt-1">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Acciones *</strong>
                          </label>
                          <select
                            :class="{ 'is-danger': errors.action }"
                            class="form-control"
                            name="state"
                            id="state"
                            v-model="formA.action"
                          >
                            <option value="null" disabled selected
                              >Seleccione una acción
                            </option>
                            <option value="reemplazar">Reemplazar</option>
                            <option value="sumar">Sumar</option>
                          </select>
                          <span
                            v-if="errors.action"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.action }}</span
                          >
                        </div>
                      </div>

                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Campos *</strong>
                          </label>
                          <select
                            :class="{ 'is-danger': errors.field }"
                            class="form-control"
                            name="state"
                            id="state"
                            v-model="formA.field"
                          >
                            <option value="null" disabled selected
                              >Seleccione un campo</option
                            >
                            <option value="punto">Puntos</option>
                            <option value="evento">Puntos de eventos</option>
                          </select>
                          <span
                            v-if="errors.field"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.field }}</span
                          >
                        </div>
                      </div>

                      <div
                        class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3"
                      >
                        <button
                          data-dismiss="modal"
                          type="button"
                          class="btn btn-secondary btn-sm btn-block button-login"
                        >
                          Cancelar
                        </button>
                      </div>
                      <div
                        class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3 mb-3"
                      >
                        <button
                          @click="modalConfirmar()"
                          type="button"
                          class="btn btn-danger btn-sm btn-block button-login"
                        >
                          <template v-if="loading.changeDoc">
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Cargando...
                          </template>
                          <template v-else>Adjuntar</template>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import vPagination from "vue-plain-pagination";
import readXlsFile from 'read-excel-file';

export default {
  components: { vPagination },
  data() {
    return {
      errorsFile: false,
      errorsFile2: false,
      totalPages: 4,
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link"
      },
      totaItems: null,
      currentPage: 1,
      listD: [],
      distri: null,
      items: [],
      searchN: "Buscar lubricadores por cédula o por correo",
      numC: 0,
      currenNumC: 0,
      form: {
        event_points: "",
        id: 0,
        name: "",
        points: "",
        email: ""
      },
      currentFrom: null,
      formA: {
        field: null,
        action: null,
        file: null
      },
      errors: {
        id: 0,
        name: false,
        email: false,
        points: false,
        event_points: false
      },
      loading: {
        history: false,
        changeDoc: false,
        modal: false
      },
      paginate: ["items"],
      page: 1,
      isWon: false,
      validateAction: false, // valida que debe consumir al momento de cambiar página en el watch

      // Modal para inscripción de Códigos
      codesForm: {
        idUser: null,
        // lote: null,
        codesFile: [],
      },
      codesErrors: {
        // lote: false,
        codesFile: false,
      }
    };
  },
  methods: {
    irR(){
      this.$router.push({name: "adminReports"});
    },
    modalConfirmar() {
      if (
        this.formA.action == null ||
        this.formA.field == null ||
        this.formA.file == null
      ) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops..",
          text: "Los campos marcados con (*) son obligatorios"
        });
        return false;
      }
      this.$swal({
        title: "Cofirmación de actualización",
        text:
          "¿Está seguro de " +
          this.formA.action +
          " la información del (los) " +
          this.formA.field +
          "(s) ?",
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "cancelar",
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#1da5df",
        confirmButtonText: "Actualizar"
      }).then(result => {
        if (result.value) {
          this.saveMasive();
        }
      });
    },
    saveMasive() {
      const data = new FormData();
      data.append("file", this.formA.file);
      data.append("field", this.formA.field);
      data.append("action", this.formA.action);
      this.loading.modal = true;
      axios
        .post("superAdmin/points/masive/update", data, { timeout: 25000 })
        .then(res => {
          if (res.data.cod == 0) {
            this.formA.file = null;
            this.formA.field = null;
            this.formA.action = null;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
          }
          this.loading.modal = false;
          $("#modalUpdateM").modal("hide");
        })
        .catch(error => {
          this.loading.modal = false;
          $("#modalUpdateM").modal("hide");
          if (error.code == "ECONNABORTED") {
            this.formA.file = null;
            this.formA.field = null;
            this.formA.action = null;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "info",
              title: "Información",
              text:
                "Estamos trabajando en la actualización de los datos, por favor diríjase a la sección de reportes."
            });
          } else {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops..",
              text: error.response.data.message
            });
          }
        });
    },
    modalM() {
      $("#modalUpdateM").modal("show");
    },
    onfileSelected(event) {
      let app = this;
      var fileSize = null;
      var extension = null;
      // var url = null;
      fileSize = event.target.files[0].size;
      extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        this.errorsFile = "El archivo no debe superar 1MB. ";
        return false;
      }
      if (extension[1] != "csv") {
        this.errorsFile2 = " La extensión es inválida. ";
        return false;
      } else {
        this.errorsFile = false;
        this.errorsFile2 = false;
        app.formA.file = event.target.files[0];
      }
    },
    getData() {
      this.items = [];
      this.loading.history = true;
      this.validateAction = false;
      axios
        .get("superAdmin/all/lubricators?page=" + this.currentPage)
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data.data;
            this.totaItems = res.data.data.total;
            this.totalPages = res.data.data.last_page;
          }
          this.loading.history = false;
        })
        .catch(() => {
          this.loading.history = false;
        });
    },
    getDistribuidor() {
      axios
        .get("superAdmin/all/distributors")
        .then(res => {
          if (res.data.cod == 0) {
            this.listD = res.data.data;
          }
        })
        .catch(() => {});
    },
    update(data) {
      this.form = data;
      this.currentFrom = data.event_points;
      if(data.coupon1.length != 0){
        this.numC = data.coupon1[0].amount;
        this.currenNumC = data.coupon1[0].amount;
      } else {
        this.numC = null;
        this.currenNumC = null;
      }
      $("#modalUpdateL").modal("show");
    },
    registerCodes(item){
      this.codesForm.idUser = item.id;
      $("#modalRegisterCodes").modal("show");
    },
    onfileSelectedExcel() {
      const file = this.$refs.codesForm.files[0];
      readXlsFile(file).then((rows) => {
        rows.forEach(row => {
          this.codesForm.codesFile.push(row[0]);
        });
        // console.log('this.codesForm.codesFile ', this.codesForm.codesFile);
      });
    },
    validateCodes(){
      // if(this.codesForm.lote == null){
      //   this.codesErrors.lote = "El lote es requerido.";
      //   return false;
      // }
      if(this.codesForm.codesFile.length == 0){
        this.codesErrors.codesFile = "Los códigos son requeridos.";
        return false;
      }
      if(!this.codesErrors.codesFile){
        return true;
      }
    },
    assignCodes(){
      if(this.validateCodes()){
        this.loading.changeDoc = true;
        axios
          .post("superAdmin/registered-codes/", this.codesForm)
          .then((res) => {
            // console.log('res ', JSON.stringify(res));
            if (res.data.cod == 0) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: res.data.message,
                confirmButtonColor: "#dc3545"
              });
            } else {
              this.$swal({
                icon: "warning",
                title: "Oops!",
                text: res.data.message,
                confirmButtonColor: "#dc3545"
              });
            }
            this.loading.changeDoc = false;
            $("#modalRegisterCodes").modal("hide");
            this.getData();
            this.clearForm();
          })
          .catch(error => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      }
    },
    clearForm(){
      // Limpiar formulario y avisos
      // this.codesForm.lote = null;
      this.codesForm.codesFile = [];
      this.$refs.codesForm.value = null;
      setTimeout(() => {
        // this.codesErrors.lote = false;
        this.codesErrors.codesFile = false;
      }, 500);
    },
    searchByType(){
      this.items = [];
      this.loading.history = true;
      var data = {
        distributorId: this.distri + ""
      };

      if(this.distri == "null" || this.distri == null){
        this.getData();
        return false;
      }
      this.validateAction = true;
      axios
      .post("superAdmin/lubricator/list?page=" + this.currentPage, data)
      .then(res => {
        if (res.data.cod == 0) {
          this.items = res.data.data.data;
          this.totaItems = res.data.data.total;
          this.totalPages = res.data.data.last_page;
        }
        this.loading.history = false;
      })
      .catch(error => {
        this.loading.history = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    search(){
      this.items = [];
      this.loading.history = true;
      var data = {
        documentOrEmail: this.searchN,
        // distributorId: this.distri + ""
      };

      if(
        // (this.distri == "null" || this.distri == null) &&
        this.searchN == null || this.searchN == "Buscar lubricadores por cédula o por correo"
      ){
        this.getData();
        return false;
      }
      this.validateAction = true;
      axios
        .post("superAdmin/lubricator/list?page=" + this.currentPage, data)
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data.data;
            this.totaItems = res.data.data.total;
            this.totalPages = res.data.data.last_page;
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    validform() {
      if (!this.form.name) {
        this.errors.name = "El nombre del producto es requerido.";
      }
      if (!this.form.description) {
        this.errors.description = "La descripción del producto es requerida.";
      }
      if (!this.form.price) {
        this.errors.price = "El precio del producto es requerido.";
      }
      if (!this.form.status) {
        this.errors.status = "El estado del producto es requerido.";
      }

      if (
        !this.errors.name &&
        !this.errors.status &&
        !this.errors.description
      ) {
        return true;
      }
      return false;
    },
    updatePublication() {      
      var data = {
        points: this.numC,
        eventPoints: this.form.event_points
      };

      if(this.numC == this.currenNumC){
        data.points = null;
      }

      if(this.form.event_points == this.currentFrom){
        data.eventPoints = null;
      }

      this.loading.changeDoc = true;
      axios
        .put("superAdmin/points/update/" + this.form.id, data)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
          }
          this.getData();
          this.loading.changeDoc = false;
          $("#modalUpdateL").modal("hide");
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Error",
            text: error.response.data.message
          });
        });
    },
    pageChange(toPage) {
      this.page = toPage;
    },
    clearInput() {
      this.searchN = "";
    },
  },
  mounted() {
    this.getData();
    this.pageChange(1);
    this.getDistribuidor();
  },
  watch: {
    currentPage: function() {
      if (this.validateAction) {
        this.search();
      } else {
        this.getData();
      }
    },
    searchN: function() {},
    "form.name": function(newV) {
      if (!newV) {
        this.errors.name = "El nombre del producto es requerido.";
      } else {
        this.errors.name = false;
      }
    },
    "form.description": function(newV) {
      if (!newV) {
        this.errors.description = "La descripción del producto es requerida.";
      } else {
        this.errors.description = false;
      }
    },
    "form.status": function(newV) {
      if (!newV) {
        this.errors.status = "El estado del producto es requerido.";
      } else {
        this.errors.status = false;
      }
    },

    // "codesForm.lote": function(n) {
    //   if (!n) {
    //     this.codesErrors.lote = "El lote es requerido.";
    //   } else {
    //     this.codesErrors.lote = false;
    //     this.codesForm.lote = this.codesForm.lote.toUpperCase();
    //   }
    // },
    "codesForm.codesFile": function(n) {
      if (!n) {
        this.codesErrors.codesFile = "Los códigos son requeridos.";
      } else {
        this.codesErrors.codesFile = false;
      }
    },
  }
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.page-link {
  border-radius: 100px;
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #dc3545;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  color: #000;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
